import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./style.css";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { Link } from "react-router-dom";
import Labels from "../../services/apiLabels";
import { ShimmerThumbnail } from "react-shimmer-effects";
import {
  CAR_DETAIL_UPDATE,
  ADD_CAR_FEATURES,
  POST,
  CHAKBOX_LIST,
  GET,
} from "../../constant";
import SearchCity from "../../components/SearchCity";
import InputTypes from "../../components/InputTypes";

export const CarUpdate = ({
  car_data,
  getcardetail,
  evaluation_id_,
  loading,
  carfeatureadd,
  divindex,
}) => {
  useEffect(() => {
    getcardetail();
  }, []);

  const [index, setIndex] = useState(0);
  const [bar, setbar] = useState(0);
  const [saving, setSaving] = useState(false);

  const nextSlide = () => {
    if (saving) return;

    const advance = () => {
      if (index < car_data.length) setIndex((i) => i + 1);
      setbar((b) => b + 100 / Math.max(car_data.length, 1));
    };

    if (car_data[index]) {
      setSaving(true);
      carfeatureadd(
        {
          evaluation: evaluation_id_,
          question: car_data[index]["question_id"],
          feature: divindex[index],
        },
        (response) => {
          setSaving(false);
          if (response?.message?.type === "success") {
            advance();
          }
        }
      );
      return;
    }

    advance();
  };

  const prevSlide = () => {
    if (saving) return;
    if (index > 0) {
      setIndex((i) => i - 1);
      setbar((b) => b - 100 / Math.max(car_data.length, 1));
    }
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
    },
  }));

  return (
    <>
      <div className="aaaaaa">
        <div className="p_wrap mt-2">
          <BorderLinearProgress
            variant="determinate"
            className="progresbar"
            value={bar}
          />
        </div>
      </div>

      <main>
        {loading ? (
          <>
            <div className="my-4">
              <ShimmerThumbnail height={200} rounded />
            </div>

            <div className="p-5">
              <ShimmerThumbnail height={60} width={400} rounded />
              <ShimmerThumbnail height={60} width={400} rounded />
              <ShimmerThumbnail height={60} width={400} rounded />
            </div>
          </>
        ) : index < car_data.length ? (
          <InputTypes data={car_data[index]} index_of={index} />
        ) : (
          <SearchCity />
        )}

        <div className="container-fluied  botm_wrap">
          <div className="row d-flex justify-content-center  ">
            <div className="col-6 d-flex text-center justify-content-center">
              <Link to="/dealers/carsteps" className="my-3">
                Save & exit
              </Link>
              <button
                type="button"
                onClick={prevSlide}
                className="back_btn mx-4"
                disabled={saving}
              >
                Previous
              </button>
              {index < car_data.length ? (
                <button
                  type="button"
                  onClick={nextSlide}
                  className="next_btn"
                  disabled={saving}
                >
                  {saving ? "Saving…" : "Next"}
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

const mapStateToProps = (state) => ({
  car_data: state.cardeailupdate.data,
  loading: state.cardeailupdate.loading,
  divindex: state.cardeailupdate.divindex,
  userinfo: state.cardeailupdate.userinfo,
  evaluation_id_: state.sellMyCar.evaluation_create.id,
});
const mapDispatchToProps = (dispatch) => ({
  carfeatureadd: (data, callBack) =>
    dispatch({
      type: ADD_CAR_FEATURES,
      payload: {
        type: ADD_CAR_FEATURES,
        method: POST,
        label: Labels.add_feaderes,
        hideOverlayLoader: true,
        data,
        callBack,
      },
    }),

  inp_chk_action: (data) =>
    dispatch({
      type: CHAKBOX_LIST,
      payload: {
        data,
      },
    }),

  getcardetail: () =>
    dispatch({
      type: CAR_DETAIL_UPDATE,
      payload: {
        type: CAR_DETAIL_UPDATE,
        label: Labels.carDetail_Update,
        method: GET,
        hideOverlayLoader: true,
      },
    }),
});
export default connect(mapStateToProps, mapDispatchToProps)(CarUpdate);
